import { AssignmentModel } from 'api/model';
import { millisecondsInHour } from 'date-fns';
import { BasicFormState } from 'hooks/useForm';
import { AssignmentField } from './types';

/** Fast tid (ms) som formulärets timfält visar den: timmar med högst två decimaler, '' när den saknas. */
export const fixedTimeToHoursInput = (fixedAssignmentTime?: number | null) =>
  fixedAssignmentTime !== undefined && fixedAssignmentTime !== null
    ? (
        Math.round(fixedAssignmentTime / (millisecondsInHour / 100)) / 100
      ).toString()
    : '';

const routeFields = [
  [AssignmentField.fromAddress, 'fromAddress'],
  [AssignmentField.fromZip, 'fromZip'],
  [AssignmentField.fromCity, 'fromCity'],
  [AssignmentField.toAddress, 'toAddress'],
  [AssignmentField.toZip, 'toZip'],
  [AssignmentField.toCity, 'toCity'],
] as const;

/**
 * Värdet "Fast uppdragstid (h)" får när fältet är låst, dvs. samma bedömning som backend gör vid
 * spar (CaseLogic.UpdateCaseAssignment). Persontransport får ingen fast tid. På ett elbilsärende
 * eller en samåkning sätts fast tid bara av Efterkontroll och SuperAdmin, och för alla andra står
 * deras värde kvar så länge ärendet redan omfattades av regeln (`ruleAppliedBefore`: var elbil
 * respektive samåkning), benet är sparat och dess rutt är oförändrad. Annars rensas det, eftersom
 * det hör till den gamla rutten.
 */
export const getLockedFixedTimeInHours = (
  state: BasicFormState<AssignmentField>,
  unmodifiedAssignment: AssignmentModel | undefined,
  {
    isPersonalTransport,
    ruleAppliedBefore,
  }: { isPersonalTransport: boolean; ruleAppliedBefore: boolean }
): string => {
  const routeUnchanged =
    !!unmodifiedAssignment &&
    state[AssignmentField.isNewAssignment] !== 'true' &&
    state[AssignmentField.addingStopOver] !== 'true' &&
    routeFields.every(
      ([field, key]) =>
        (state[field] ?? '').trim() === (unmodifiedAssignment[key] ?? '').trim()
    );

  return !isPersonalTransport && ruleAppliedBefore && routeUnchanged
    ? fixedTimeToHoursInput(unmodifiedAssignment?.fixedAssignmentTime)
    : '';
};
